import React from "react";
import { Modal, Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

function LoadingModal({ openLoadingModal, body }) {
  return (
    <Modal
      open={openLoadingModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Typography className="font-bold">{body}</Typography>
        <CircularProgress />
      </Box>
    </Modal>
  );
}

LoadingModal.propTypes = {
  body: PropTypes.string.isRequired,
  openLoadingModal: PropTypes.func.isRequired,
};

export default LoadingModal;
